import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../utils/AuthContext';

const ViewPaperSets = () => {
  const [paperSets, setPaperSets] = useState([]);
  const [filterIsActive, setFilterIsActive] = useState('all');
  const { auth } = useAuth();

  useEffect(() => {
    const fetchPaperSets = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/paperset`, {
          headers: {
            Authorization: `Bearer ${auth.token}`
          }
        });
        
        const data = response.data.$values;
        setPaperSets(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching paper sets:', error.response ? error.response.data : error.message);
        setPaperSets([]);
      }
    };

    fetchPaperSets();
  }, [auth.token]);

  const filteredPaperSets = paperSets.filter((ps) => {
    if (filterIsActive === 'true') return ps.isActive;
    if (filterIsActive === 'false') return !ps.isActive;
    return true; // if 'all' is selected
  });

  if (!Array.isArray(paperSets)) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-8">
      <h2 className="text-3xl font-semibold mb-6">View Paper Sets</h2>
      <div className="mb-4">
        <label className="mr-2">Filter by Active Status:</label>
        <select
          value={filterIsActive}
          onChange={(e) => setFilterIsActive(e.target.value)}
          className="p-2 border border-gray-300 rounded"
        >
          <option value="all">All</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </div>
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <table className="min-w-full bg-white">
          <thead>
            <tr>
              <th className="py-2 px-4 bg-gray-200 text-left text-sm font-semibold text-gray-700">Title</th>
              <th className="py-2 px-4 bg-gray-200 text-left text-sm font-semibold text-gray-700">Number of Questions</th>
              <th className="py-2 px-4 bg-gray-200 text-left text-sm font-semibold text-gray-700">Created Date</th>
              <th className="py-2 px-4 bg-gray-200 text-left text-sm font-semibold text-gray-700">Is Active</th>
            </tr>
          </thead>
          <tbody>
            {filteredPaperSets.map((paperSet) => (
              <tr key={paperSet.paperSetId} className="border-t">
                <td className="py-2 px-4 text-sm text-gray-700">{paperSet.title}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{paperSet.numberOfQuestions}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{new Date(paperSet.createdDate).toLocaleDateString()}</td>
                <td className="py-2 px-4 text-sm text-gray-700">{paperSet.isActive ? 'Active' : 'Inactive'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ViewPaperSets;
